import {getFinalKilogramsConversion, getFinalStonesConversion,
  getFinalPoundsConversion, getFinalOuncesConversion,
  getFinalGramsConversion} from './WeightConversionTracker';

function getConversion(temp,conType) {
    let result = '';
    switch(conType.slice(0,2)) {
        case 'kl':
        result = getFinalKilogramsConversion(temp,conType);
            break;
        case 'st':
        result = getFinalStonesConversion(temp,conType);
            break;
        case 'pd':
        result = getFinalPoundsConversion(temp,conType);
            break;
        case 'oz':
        result = getFinalOuncesConversion(temp,conType);
            break;
        case 'gr':
        result = getFinalGramsConversion(temp,conType);
            break;
        default:
            result = '';
    }

    return result;
}

export{getConversion};

